export default __webpack_public_path__ + "navigation-examples-route-alerts-960-91a97968df23532c4079547ea104ff2c.webp";